var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7232 9.12522C12.438 8.82298 11.9573 8.82298 11.6721 9.12521C11.4093 9.40364 11.4093 9.83865 11.6721 10.1171L15.8079 14.5001L11.6721 18.8831C11.4093 19.1615 11.4093 19.5965 11.6721 19.8749C11.9573 20.1772 12.438 20.1772 12.7232 19.8749L17.1474 15.1864C17.511 14.8011 17.511 14.1991 17.1474 13.8138L12.7232 9.12522Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowArrowIcon);
export default __webpack_public_path__ + "static/media/how-arrow-icon.2660e5b4314929b6302ff8a484f8394d.svg";
export { ForwardRef as ReactComponent };